import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import type * as models from '../../models'
import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.userForAgentAssignment.DOC}
  query UsersForAgentAssignment($ids: [ID!], $quantity: Int, $cursor: String) {
    users(ids: $ids, quantity: $quantity, cursor: $cursor) {
      items {
        ...FragmentUserForAgentAssignment
      }
      nextCursor
    }
  }
`

// NOTE: Transforming only properties needed for assignment process
export const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.UsersForAgentAssignmentQuery,
    ents.core.common.Response.For.Pagination<models.User>,
    'users'
  >(
    'users',
    graphql.transformers.OUT.object({
      items: graphql.transformers.OUT.default(
        graphql.transformers.OUT.list(
          fragments.userForAgentAssignment.TRANSFORMER,
          {
            onNullish: 'remove',
          },
        ),
        [],
      ),
      nextCursor: graphql.transformers.OUT.nullable(transformers.PASS_THROUGH),
    }),
  ),
  { items: [], nextCursor: undefined },
)

export const execute = graphql.createExecutor<
  graphql.schema.UsersForAgentAssignmentQuery,
  ents.core.common.Response.For.Pagination<models.User>,
  graphql.schema.UsersForAgentAssignmentQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
